module.exports = __webpack_public_path__ + "img/Lebanon.e4cfe649.svg";